const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const isValidEmail = email => {
  if (!email || typeof email !== 'string') return false
  return EMAIL_REGEX.test(email.trim())
}

export const getEmailValidationState = entry => {
  const hasContacto = entry.nombre && entry.nombre.trim() !== ''
  const hasEmail = entry.email && entry.email.trim() !== ''
  const emailValido = hasEmail && isValidEmail(entry.email)

  if (hasContacto && emailValido) return 'success'
  if (hasEmail && !emailValido) return 'error'
  return 'warning'
}

export const isEmailEntryValid = entry => {
  return getEmailValidationState(entry) === 'success'
}

export const hasValidEmail = emails => {
  if (!emails || emails.length === 0) return false
  return emails.some(isEmailEntryValid)
}
